import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import PrimaryButton from './buttons/PrimaryButton';
import ParagraphText from './paragraphTexts/ParagraphText';
import SectionTitle from './titles/SectionTitle';
import AboutImg from '../assets/images/about.png';

const AboutStyles = styled.div`
  padding: 10rem 0;
  .about__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .about__subtitle {
    margin-bottom: 1rem;
    font-weight: 600;
    text-transform: capitalize;
    color: var(--mediumSlateBlue);
  }
  .about__title {
    margin-bottom: 2rem;
    max-width: 350px;
  }
  .about__desc {
    margin-bottom: 2rem;
    max-width: 300px;
  }
  @media only screen and (max-width: 768px) {
    .about__wrapper {
      flex-direction: column;
    }
    .about__img {
      max-width: 400px;
    }
  }
`;

function AboutSection() {
  return (
    <AboutStyles id="about">
      <div className="container">
        <div className="about__wrapper">
          <div className="about__img">
            <img
              src="https://cdn.discordapp.com/attachments/1149012703847915563/1156338443966742669/ac42c7b47d949139c18b3260d08ef16e-removebg-preview.png"
              style={{ height: 500, width: 500 }}
              alt="CriminalMW"
            />
          </div>
          <div className="about__info">
            <ParagraphText className="about__subtitle">
              Por que escolher a Criminal?
            </ParagraphText>
            <SectionTitle className="about__title">
              Resumo rápido é somente aqui !
            </SectionTitle>
            <ParagraphText className="about__desc">
              Nós da equipe Criminal trabalhamos dia e noite para adicionar
              funções novas semanalmente e bancos/mecanismos novos para deixar
              seu trampo ainda melhor
            </ParagraphText>
            <PrimaryButton buttonType={Link} to="contact" smooth>
              Comprar
            </PrimaryButton>
          </div>
        </div>
      </div>
    </AboutStyles>
  );
}

export default AboutSection;
